export var APP_LOAD_ERROR_FLOW = 'app-load';